export const tableStyles = {
  wrapper: {
    background: '#ffffff',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    overflow: 'hidden',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  scroll: {
    flex: 1,
    overflow: 'auto',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
    minHeight: 0,
    width: '100%',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '960px',
  },
  thead: {
    background: '#f8fafc',
    borderBottom: '1px solid #e2e8f0',
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
  th: {
    padding: '10px 14px',
    textAlign: 'left',
    fontSize: '11px',
    fontWeight: 700,
    color: '#64748b',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '12px 14px',
    fontSize: '13px',
    color: '#334155',
    verticalAlign: 'middle',
  },
  row: (selected, index) => ({
    borderBottom: '1px solid #f1f5f9',
    background: selected ? '#eff6ff' : index % 2 === 0 ? '#ffffff' : '#fafbfc',
    transition: 'background 0.12s',
  }),
  empty: {
    padding: '48px 24px',
    textAlign: 'center',
    color: '#94a3b8',
    fontSize: '14px',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    borderTop: '1px solid #e2e8f0',
    background: '#fafbfc',
    flexWrap: 'wrap',
    gap: '8px',
  },
};

export const actionBtn = (bg, color = '#ffffff') => ({
  padding: '6px 10px',
  background: bg,
  color,
  border: 'none',
  borderRadius: '6px',
  fontSize: '12px',
  fontWeight: 600,
  cursor: 'pointer',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  whiteSpace: 'nowrap',
});

export const statusBadge = (bg, color) => ({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '4px 10px',
  borderRadius: '6px',
  fontSize: '12px',
  fontWeight: 600,
  backgroundColor: bg,
  color,
  whiteSpace: 'nowrap',
});
